import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const QuestionContainer = styled.div`
    display: flex;
    ${media.mobileDevice`
         flex-direction: column;
    `};
`;
export const QuestionTitle = styled.div`
    font-size: 14px;
    color: #202124;
    font-family: AvenirNextWorld demi;
    text-align: left;
    width: 70%;
    ${media.mobileDevice`
        width: 100%; 
    `};
    &:after {
        content: '*';
        color: red;
        padding-left: 3px;
    }
`;
export const RadioButtonView = styled.div`
    display: flex;
    width: 30%;
    ${media.mobileDevice`
        width: 100%;
        margin-top: 20px;
    `};
`;
